import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import Card from '../../components/Card/Card';
import Timeline from '../../components/Timeline/Timeline';
import './PolicyDetails.scss';

export class PolicyDetails extends Component {
    render() {
        if (!this.props.customer.isAuthenticated) return null;

        return (
            <Timeline
                seperator="POLICY DETAILS"
                heading="your policy comparison"
                icon={
                    <FontAwesome
                        className="primary-yellow con md image_center icon15"
                        name="file"
                        datacy="file"
                        size="2x"
                    />
                }>
                Here are the details of your new Safeco policy.
                <div className="flex flex-row policy-details">
                    <Card details={this.props.details} deploy={this.props.app.deploy} />
                </div>
            </Timeline>
        );
    }
}

function mapStoreToProps(store) {
    return {
        app: store.app,
        customer: store.customer,
        details: store.details
    };
}

export default connect(mapStoreToProps)(PolicyDetails);



// WEBPACK FOOTER //
// ./src/containers/PolicyDetails/PolicyDetails.jsx